import { connect } from "react-redux";
import PropTypes from "prop-types";

import BaseInputComponent from "basecomponents/BaseInputComponent";
import {
  InputField,
  TextArea,
  InputSelect,
  InputSelectSearch,
} from "../components/form";
import { SmallSpinner } from "../components/loaders";

// Utils
import { hideModal, initSearchSelect } from "../utils/domUtils";
import { getArticleStatusOptions } from "../utils/packageUtils";
import { removeNullProperties } from "../utils/jsonUtils";

// Actions
import { createArticle } from "../actions/articleActions";

class AdminAddArticleModal extends BaseInputComponent {
  modal_id = "modal_add_article";

  state = {
    name: "",
    track_code: "",
    description: "",
    status: "ST_WAITING",
    id_client: 0,
    id_package: 0,
    //
    statusOptions: [],
    clientOptions: [],
    packageOptions: [],
    needRefreshSelect: false,
    preventSetPackageOptions: false,
    errors: {},
  };

  componentDidMount() {
    this.setState({
      statusOptions: getArticleStatusOptions(),
    });
  }

  componentDidUpdate() {
    if (!this.state.needRefreshSelect) return;
    this.refreshDropDowns();
  }

  refreshDropDowns() {
    initSearchSelect({
      id: "id_client",
      selectedValue: this.state.id_client,
      onChange: (id_client) => {
        const packageOptions = this.getPackageOptions(id_client);
        this.setState({
          id_client,
          packageOptions,
          id_package: 0,
          needRefreshSelect: true,
          preventSetPackageOptions: true,
        });
      },
    });
    initSearchSelect({
      id: "id_package",
      selectedValue: this.state.id_package,
      onChange: (id_package) => {
        this.setState({
          id_package,
        });
      },
    });

    this.setState({
      needRefreshSelect: false,
    });
  }

  getPackageOptions = (id_client = null) => {
    // @ts-ignore
    const allPackages = this.props.package.elements;
    if (id_client === null || id_client === 0 || id_client === "0") {
      return allPackages.map((e) => ({
        value: e.id,
        label: `${e.id} ${e.name}`,
      }));
    }
    return allPackages
      .filter((p) => p.id_client === id_client)
      .map((e) => ({
        value: e.id,
        label: `${e.id} ${e.name}`,
      }));
  };

  static getDerivedStateFromProps(nextProps, currentState) {
    let newState = {
      errors: null,
      packageOptions: null,
      clientOptions: null,
      needRefreshSelect: false,
      changed: false,
    };
    if (nextProps.errors) {
      newState.errors = nextProps.errors;
      newState.changed = true;
    }

    if (
      nextProps.package?.elements &&
      nextProps.package.elements.length > 0 &&
      !currentState.preventSetPackageOptions &&
      currentState.packageOptions.length === 0
    ) {
      newState.packageOptions = nextProps.package.elements.map((e) => ({
        value: e.id,
        label: `${e.id} ${e.name}`,
      }));
      newState.needRefreshSelect = true;
      newState.changed = true;
    }

    if (
      nextProps.client?.elements &&
      nextProps.client.elements.length > 0 &&
      currentState.clientOptions.length === 0
    ) {
      newState.clientOptions = nextProps.client.elements.map((e) => ({
        value: e.id,
        label: `${e.code} ${e.name}`,
      }));
      newState.needRefreshSelect = true;
      newState.changed = true;
    }

    if (!newState.changed) return null;

    return removeNullProperties(newState);
  }

  isLoading(): boolean {
    // @ts-ignore
    return this.props.article.loadingOperation;
  }

  onAcceptClick = () => {
    const { name, track_code, description, status, id_client, id_package } =
      this.state;

    // @ts-ignore
    this.props.createArticle(
      {
        name,
        track_code,
        description,
        status,
        id_client,
        id_package,
      },
      (success) => {
        if (!success) return;

        this.clearForm();
        this.onCancelClick();
      }
    );
  };

  clearForm = () => {
    this.setState({
      name: "",
      track_code: "",
      description: "",
      status: "ST_WAITING",
      id_client: 0,
      id_package: 0,
      preventSetPackageOptions: false,
      needRefreshSelect: true,
    });
  };

  onCancelClick = () => {
    this.clearForm();
    hideModal(this.modal_id);
  };

  getForm = () => {
    const {
      name,
      track_code,
      description,
      status,
      id_client,
      id_package,
      //
      statusOptions,
      clientOptions,
      packageOptions,
      errors,
    } = this.state;
    const loading = this.isLoading();
    return (
      <>
        <div className="grid-2-col">
          <InputField
            id="name"
            name="name"
            value={name}
            label="Nombre"
            error={errors}
            onChange={this.onChangeTextInput}
          />
          <InputField
            id="track_code"
            name="track_code"
            value={track_code}
            label="Tracking"
            error={errors}
            onChange={this.onChangeTextInput}
          />
        </div>

        <InputSelect
          id="status"
          label="Estado"
          addNoneOption={false}
          value={status}
          options={statusOptions}
          onChange={this.onChangeTextInput}
        />

        <InputSelectSearch
          id="id_client"
          value={id_client}
          label="Cliente"
          error={errors}
          options={clientOptions}
        />
        <InputSelectSearch
          id="id_package"
          value={id_package}
          label="Paquete"
          error={errors}
          options={packageOptions}
        />

        <div>
          <TextArea
            id="description"
            name="description"
            label="Descripcion (opcional)"
            value={description}
            onChange={this.onChangeTextInput}
          />
        </div>

        {loading && <SmallSpinner center={true} />}
      </>
    );
  };

  render() {
    return (
      <div
        className="modal fade"
        id={this.modal_id}
        role="dialog"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Crear nuevo articulo</h5>
            </div>
            <div className="modal-body">{this.getForm()}</div>
            <div className="modal-footer">
              <div className="flex-2-separated">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={this.onCancelClick}
                >
                  Cancelar
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.onAcceptClick}
                >
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// @ts-ignore
AdminAddArticleModal.propTypes = {
  article: PropTypes.object.isRequired,
  package: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  createArticle: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  article: state.article,
  package: state.package,
  client: state.client,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  createArticle,
})(AdminAddArticleModal);
